import { type SxProps, type Theme } from '@mui/system';

export const dialogSx: SxProps<Theme> = {
  marginTop: '20px',
  '& .wrapper': {
    width: '100vw',
    height: '100vh',
    zIndex: 100,
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& .controller': {
      width: {
        xs: '90%',
        lg: '1200px',
      },
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      gap: '6px',
      '& .bi-x': {
        fontSize: '48px',
        color: '#FFFFFF',
        cursor: 'pointer',
      },
    },
    '& .content': {
      '& img': {
        width: {
          xs: '90%',
          lg: '1200px',
        },
        height: '90%',
        objectFit: 'cover',
      },
    },
  },
};
